<template>
  <div class="pt-3">
    <div v-if="!loading" class="d-flex justify-center">
      <div v-if="section" class="_temp_list">
        <on-section />

        <v-card flat class="rounded_max mb-3">
          <div
            :class="`temp_title `"
            :style="`background:${section.color ? section.color : '#006341'};`"
          >
            <img
              src="../../../../assets/img/gundam/LMS Aset Banner Section.png"
              class="img_banner_section"
              alt="banner id"
            />
            <div class="content_banner pa-3">
              <v-row no-gutters>
                <v-col cols="10" lg="6" md="6">
                  <div
                    class="d-flex flex-column justify-space-between"
                    style="min-height: 170px"
                  >
                    <v-tooltip top>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          color="white"
                          v-bind="attrs"
                          v-on="on"
                          :to="`/course/inclass/${section.course_id}`"
                          icon
                          ><v-icon>mdi-reply</v-icon></v-btn
                        >
                      </template>
                      <span>Back</span>
                    </v-tooltip>
                    <div class="d-flex align-center">
                      <h3 class="white--text">{{ section.title }}</h3>
                      <v-btn icon dark @click="detil = !detil">
                        <v-icon>mdi-information-outline</v-icon>
                      </v-btn>
                    </div>
                  </div>
                </v-col>
                <v-col cols="2" lg="6" md="6">
                  <div class="d-flex justify-end">
                    <v-btn
                      small
                      fab
                      depressed
                      color="#fff"
                      @click="toConfig(section.id)"
                      v-if="
                        role == 'SUPERADMIN' ||
                        permissions.includes('LD') ||
                        permissions.includes('TEACHER')
                      "
                    >
                      <v-icon>mdi-cog</v-icon>
                    </v-btn>
                  </div>
                </v-col>
              </v-row>
            </div>
          </div>
          <v-row no-gutters v-if="detil">
            <v-col cols="12" md="6" lg="6">
              <div class="pa-3">
                <v-row>
                  <v-col cols="1">
                    <v-icon>mdi-calendar</v-icon>
                  </v-col>
                  <v-col cols="5">
                    <b class="small_txt">Start</b>
                    <p class="default_txt">{{ section.start_date }}</p>
                  </v-col>
                  <v-col cols="5">
                    <b class="small_txt">End</b>
                    <p class="default_txt">{{ section.end_date }}</p>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="1">
                    <v-icon>mdi-text</v-icon>
                  </v-col>
                  <v-col cols="11">
                    <b class="small_txt">About Section</b>
                    <p class="default_txt">{{ section.description }}</p>
                  </v-col>
                </v-row>
              </div>
            </v-col>
          </v-row>
        </v-card>
        <div class="d-flex justify-space-between mb-4">
          <title-page title="Module List" />
          <div
            v-if="
              role == 'SUPERADMIN' ||
              permissions.includes('LD') ||
              permissions.includes('TEACHER')
            "
          >
            <v-menu offset-y nudge-bottom="5px">
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  :class="`text-capitalize rounded-lg`"
                  :color="section.color"
                  v-if="!creating"
                  depressed
                  dark
                  v-bind="attrs"
                  v-on="on"
                  ><v-icon class="mr-1">mdi-bookshelf </v-icon> Create
                  Module</v-btn
                >
              </template>
              <v-card min-width="200px" flat>
                <v-list dense>
                  <v-list-item-group v-model="selectedModule" color="primary">
                    <v-list-item
                      v-for="(item, i) in moduleType"
                      :key="i"
                      @click="createModule(item)"
                    >
                      <v-list-item-icon>
                        <v-icon> {{ item.icon }} </v-icon>
                      </v-list-item-icon>
                      <v-list-item-content>
                        <v-list-item-title
                          v-text="item.description"
                        ></v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list-item-group>
                </v-list>
              </v-card>
            </v-menu>
            <v-btn
              :class="`text-capitalize rounded-lg`"
              v-if="creating"
              :color="section.color"
              depressed
              dark
            >
              <v-progress-circular
                indeterminate
                class="mr-2"
                color="#fff"
                size="20"
              ></v-progress-circular>
              Creating</v-btn
            >
          </div>
        </div>
        <list-module
          v-if="
            role == 'SUPERADMIN' ||
            permissions.includes('LD') ||
            permissions.includes('GUEST') ||
            permissions.includes('TEACHER')
          "
          :color="section.color"
          :section="section"
        />
        <list-module-scholar
          :color="section.color"
          :type="role == 'SCHOLAR' ? 'scholar' : 'anotherRole'"
          v-if="
            !permissions.includes('LD') &&
            (role == 'SCHOLAR' ||
              permissions.includes('MENTOR') ||
              permissions.includes('UPCM') ||
              permissions.includes('ELSN') ||
              permissions.includes('FASILITATOR'))
          "
        />
      </div>
    </div>
    <div v-if="loading">
      <loading-lg />
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import titlePage from "../../../../components/atom/titlePage.vue";
import OnSection from "../../../../components/course/breadcrumbs/onSection";
import ListModule from "../../module/admin/listModule.vue";
import ListModuleScholar from "../../module/scholar/listModuleScholar.vue";
export default {
  components: { titlePage, ListModule, ListModuleScholar, OnSection },
  name: "sectionDetail",
  computed: {
    ...mapState({
      role: (state) => state.role,
      permissions: (state) => state.permissions,
    }),
  },
  data() {
    return {
      detil: false,
      loading: false,
      creating: false,
      section: null,
      dataSet: null,
      moduleType: null,
      selectedModule: null,
      icon: [
        {
          id: 1,
          mdi: "mdi-order-bool-ascending-variant",
        },
        {
          id: 2,
          mdi: "mdi-clipboard-check",
        },

        {
          id: 3,
          mdi: "mdi-book-check",
        },
        {
          id: 4,
          mdi: "mdi-text-box-check",
        },
        {
          id: 5,
          mdi: "mdi-notebook-check",
        },
        {
          id: 6,
          mdi: "mdi-book-sync-outline",
        },
        {
          id: 7,
          mdi: "mdi-puzzle-check",
        },
        {
          id: 8,
          mdi: "mdi-account-check-outline",
        },
      ],
    };
  },

  mounted() {
    this.fetchData();
    this.typeModule();
  },
  methods: {
    fetchData() {
      this.loading = true;
      let data = {
        path: `manage/course/section?filter[id]=${this.$route.params.idSection}`,
      };
      this.$store
        .dispatch("course/getData", data)
        .then((data) => {
          this.loading = false;
          this.section = data.data[0];
        })
        .catch((e) => {
          this.$store.dispatch("notify", {
            msg: e.message,
            type: "error",
          });
          this.loading = false;
        });
    },
    createModule(item) {
      this.creating = true;
      let section = this.$route.params.idSection;
      let course = this.$route.params.idCourse;
      let end = `${this.$date().add(1, "day").format("YYYY-MM-DD")} 23:59`;

      let body = {
        course_section_id: section,
        module_id: item.id,
        title: item.description,
        description: "write module description here",
        end_module: this.$date(new Date(end)).unix(),
        form_assign: {
          title: item.description,
          description: "write module description here",
        },
      };
      let data = {
        path: `manage/course/section/module/assign`,
        body: body,
      };
      this.$store
        .dispatch("user/postApi", data)
        .then((data) => {
          this.$store.dispatch("notify", {
            msg: data.message,
            type: "success",
          });
          this.$router.push(
            `/module/inclass/${section}/${course}/${data.data.module_id}/${data.data.instance_id}/${item.title}/config`,
          );
          this.creating = false;
        })
        .catch((err) => {
          this.$store.dispatch("notify", {
            msg: err.message,
            type: "error",
          });
          this.creating = false;
        });
    },

    typeModule() {
      this.loading = true;
      let data = {
        path: `manage/module`,
      };
      this.$store
        .dispatch("course/getData", data)
        .then((data) => {
          this.loading = false;
          this.moduleType = data.data;
          this.moduleType.forEach((el) => {
            this.icon.forEach((ico) => {
              if (el.id == ico.id) {
                el["icon"] = ico.mdi;
              }
            });
          });
        })
        .catch((e) => {
          this.$store.dispatch("notify", {
            msg: e.message,
            type: "error",
          });
          this.loading = false;
        });
    },
    toConfig(id) {
      this.$router.push(
        `/section/inclass/${id}/${this.$route.params.idCourse}/config`,
      );
    },
  },
};
</script>

<style scoped>
.strip {
  padding: 3px;
  width: 10px;
  max-height: 100%;
  border-radius: 0 !important;
}
</style>
